/** Small pieces every order screen shows the same way. */

import { useTranslation } from "react-i18next";
import { cn } from "@/lib/cn";
import { formatCalendarDate } from "@/lib/dates";
import type { OrderStatus } from "./lifecycle";

const tones: Record<OrderStatus, string> = {
  draft: "bg-stone-100 text-stone-700",
  confirmed: "bg-brand-50 text-brand-800",
  in_progress: "bg-amber-50 text-amber-800",
  completed: "bg-emerald-50 text-emerald-800",
  cancelled: "bg-stone-100 text-stone-500",
  refunded: "bg-red-50 text-red-800",
};

export function OrderStatusBadge({ status }: { status: OrderStatus }) {
  const { t } = useTranslation();
  return (
    <span className={cn("rounded-full px-2 py-0.5 text-xs font-medium", tones[status])}>
      {t(`orders.status.${status}`)}
    </span>
  );
}

/** "Due Nov 14, 2026", or nothing when no date was promised. */
export function DueDate({ date }: { date: string | null }) {
  const { t } = useTranslation();
  if (!date) return null;
  return <span>{t("orders.due", { date: formatCalendarDate(date) })}</span>;
}
